module.exports = __webpack_public_path__ + "static/media/person-sports-throwing-a-ball-svgrepo-com.00e268b6.svg";